import {
  GetDatabaseSchemaPayload,
  GetReportingColumnsPayload,
  SaveReportingColumnsResponse,
  SearchTablesResponse,
  ValidateReportsPayload,
  ValidateReportsResponse,
} from 'interfaces/report-configuration.interface';

import { coreSplitApis } from './core.api';

export const reportConfiguration = coreSplitApis
  .enhanceEndpoints({ addTagTypes: ['AvailableTables'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getDatabaseSchema: build.query<GetDatabaseSchemaPayload, void>({
        query: () => ({
          url: 'Reporting/GetDatabaseSchema',
          method: 'GET',
        }),
      }),
      getReportingColumns: build.query<GetReportingColumnsPayload, void>({
        query: () => ({
          url: 'Reporting/GetReportingColumns',
          method: 'GET',
        }),
        providesTags: ['AvailableTables'],
      }),
      validateReports: build.mutation<ValidateReportsResponse, ValidateReportsPayload>({
        query: (payload) => ({
          url: 'Reporting/ValidateReports',
          method: 'POST',
          data: payload.columns,
        }),
      }),
      saveReportingColumns: build.mutation<SaveReportingColumnsResponse, ValidateReportsPayload>({
        query: (payload) => ({
          url: 'Reporting/SaveReportingColumns',
          method: 'POST',
          data: payload.columns,
        }),
        invalidatesTags: (_, error) => (error ? [] : ['AvailableTables']),
      }),
      searchTables: build.mutation<SearchTablesResponse, void>({
        query: (payload) => ({
          url: 'Reporting/SearchTables',
          method: 'POST',
          data: payload,
        }),
      }),
    }),
    overrideExisting: false,
  });

export const {
  useGetDatabaseSchemaQuery,
  useGetReportingColumnsQuery,
  useValidateReportsMutation,
  useSaveReportingColumnsMutation,
  useSearchTablesMutation,
} = reportConfiguration;
